import { useEffect, useRef } from "react"
import type { MutableRefObject } from "react"

export function usePrevious<T>(value: T): T | undefined {
  const ref: MutableRefObject<T | undefined> = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
